import * as Sentry from '@sentry/react';

import { env } from './env.config';

/**
 * The only file allowed to import the Sentry SDK. Everything else goes through
 * `utils/logger.util.ts`, so swapping the provider touches one file.
 *
 * A no-op when VITE_SENTRY_DSN is unset — `npm run dev` works without an account.
 */
export const initSentry = (): void => {
  if (!env.VITE_SENTRY_DSN) return;

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: env.VITE_APP_RELEASE,
    // Errors only — performance tracing is out of scope and would eat the 5k/month quota.
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
};

export const isSentryEnabled = (): boolean => Boolean(env.VITE_SENTRY_DSN);

export { Sentry };
